export default __webpack_public_path__ + "static/media/home-illustration.681a2dd6.png";